<script>
	const utilities = require('utilities');
	const Grading = require('readworks-grading');
	const logger = require('utilities/logger');
	const { authenticateWithGoogleClassroom, isKnownGoogleClass } = require('utilities/googleClassroomUtilities');

	module.exports = {
		props: ['gcid', 'loading'],
		components: {
			message: require('components/message.vue').default
		},
		modelData: ['qset', 'localGCAccessToken', 'gcClassList'],
		data: function () {
			return {
				student: null,
				studentLabel: '',
				assessment: null,
				gc: true,
				questionsAssignedLookup: null,
				roster: null
			};
		},
		mounted() {
			this.$subscribe(
				'modal-opened',
				function (modalId, options) {
					if (modalId !== 'modal-mark-done') {
						return;
					}

					if (!options.student || !options.assessment) {
						utilities.closeModals();
						logger.error('Mark done modal opened missing parameters');
					}

					this.student = options.student;
					this.assessment = options.assessment;
					this.gc = !!(options.assessment.gcid || options.assessment.gca);
					this.questionsAssignedLookup = options.questionsAssignedLookup;
					this.roster = options.roster;

					this.buildLabel();
				}.bind(this)
			);
			this.$subscribe(
				'modal-closed',
				function (modalId, options) {
					if (modalId !== 'modal-mark-done') {
						return;
					}
					this.student = null;
					this.assessment = null;
					this.gc = true;
					this.questionsAssignedLookup = null;
					this.roster = null;
				}.bind(this)
			);
		},
		computed: {
			gcTokenMismatch() {
				const roster = this.roster;
				const gcid = roster && roster.gcid;
				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			},
			needsGoogleAuth() {
				const assessment = this.assessment;
				const gcid = assessment && assessment.gcid;
				const token = this.localGCAccessToken;
				const gc = this.gc;
				/* No GCA check needed - modal unused */

				return gcid && gc && (!token || this.gcTokenMismatch);
			},
			uid() {
				let student = this.student;
				let id = null;

				if (student && student.uid) {
					id = student.uid;
				}

				return id;
			},
			showResults() {
				let assessment = this.assessment;
				return assessment && assessment.showResults !== false;
			},
			grade() {
				let uid = this.uid;
				let assessment = this.assessment;
				let qset = this.qset;
				let grade = 0;
				let total = 0;
				let totalRight = 0;

				if (assessment && uid && qset && assessment.students[uid] && assessment.students[uid].answers && assessment.students[uid].answers[qset]) {
					let answers = assessment.students[uid].answers[qset];
					answers.forEach(answer => {
						// Assigned AND ("scorable" by service OR manually scored by teacher)
						if (this.questionsAssignedLookup[answer.qid] && (Grading.questionTypeIsScorable(answer.questionType) || answer.score)) {
							total++;
							let score = answer.score || 0;
							totalRight += score / 100;
						}
					});

					if (total) {
						grade = totalRight / total;
					}
				}
				return grade;
			},
			fullyGraded() {
				let assessment = this.assessment;
				let questionsAssignedLookup = this.questionsAssignedLookup;
				let uid = this.uid;
				let qset = this.qset;
				let fg = false;

				if (assessment && uid && qset && assessment.students[uid] && assessment.students[uid].answers && assessment.students[uid].answers[qset]) {
					let answers = assessment.students[uid].answers[qset];
					fg = answers.every(
						answer => !questionsAssignedLookup[answer.qid] || !Grading.questionTypeIsScorable(answer.questionType) || typeof answer.score === 'number'
					);
				}

				return fg;
			}
		},
		methods: {
			buildLabel: function () {
				var studentsArray = [];
				Object.keys(this.assessment.students).forEach(
					function (k) {
						var s = $.extend(true, {}, this.assessment.students[k]);
						s.answers = null;
						s.uid = k;
						studentsArray.push(s);
					}.bind(this)
				);

				var labels = utilities.unambiguousStudentLabels(studentsArray);

				this.studentLabel = labels[this.student.uid];
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			}
		}
	};
</script>
<style lang="scss">
	#modal-mark-done {
		.date {
			text-align: center;

			& > div {
				display: inline-block;

				&.form-row-input {
					width: auto;
				}
			}
		}
	}
</style>
<template>
	<modal
		id="modal-mark-done"
		:loading="loading">
		<div slot="header-container">
			<h2>{{ studentLabel }}'s Done</h2>
			<h3>{{ assessment.product.title }}</h3>
		</div>
		<div slot="content">
			<p>
				<template v-if="showResults"> We will let {{ studentLabel }} know that you've finished looking at their work. </template>
				<template v-if="!showResults">
					Once you have updated this assignment to share results, we will let {{ studentLabel }} know that you've finished looking at their work.
				</template>
				<template v-if="!fullyGraded"> Please note, you have not graded all answers on this assignment. </template>
			</p>
			<label v-if="gcid && assessment.gcid">
				<input
					class="input-checkbox"
					type="checkbox"
					:disabled="!!assignment"
					v-model="gc" />
				<span v-if="!assignment"> Send score to Google Classroom </span>
			</label>
			<div
				v-if="needsGoogleAuth"
				class="text-centered">
				<message
					v-if="gcTokenMismatch"
					class="text-left"
					type="error">
					Please authenticate the Google account used to manage this Classroom
				</message>
				<button
					class="button margin-bottom-small"
					@click="authenticateWithGoogle">
					Authenticate with Google
				</button>
			</div>
			<div class="text-centered">
				<button
					class="button"
					:class="{
						disabled: needsGoogleAuth
					}"
					:disabled="needsGoogleAuth"
					@click="$emit('done-grading', uid, grade, gc)">
					Mark Done
				</button>
			</div>
		</div>
	</modal>
	<!-- end #modal-mark-done -->
</template>
